import { QualityCheck, QualityCheckProps } from "../quality-check";

type ReferenceQualityCheckProps = QualityCheckProps;

export function ReferenceQualityCheck(props: ReferenceQualityCheckProps) {
  if (props.data.Name !== "Referenser") {
    throw new Error("ReferenceQualityCheck can only be used for Referenser");
  }

  return <QualityCheck {...props} disabled={false} withDefaultStatuses={false} />;
}
